
const logger = require('../logger/logger');
const validator = require('../validator/validator');
const storefrontUtility = require('../domain/storefrontUtility');
const localizationUtils = require('../domain/localizationUtils');
const domainConstants = require('../domain/constants');
const cardSettingsUtils = require('../domain/settings/cardSettingsUtils');
const cardPaymentManagement = domainConstants.externalEntities.cardPaymentManagement;
var stateManager = require('../state/stateManager.js');
var stringUtil = require('../string/stringUtil.js');
const typeUtil = require('../type/typeUtil');
var paymentSenseCardTerminalDriver = require('./paymentSense/paymentSenseCardTerminalDriver.js');
var genericCardTerminalDriver = require('./generic/genericCardTerminalDriver.js');
var handPointCardTerminalDriver = require('./handPoint/handPointCardTerminalDriver.js');
var stripeServerSideCardTerminalDriver = require('./stripe/stripeServerSideCardTerminalDriver');


module.exports.connect = function(onCompletion)
{
    var creditCardTerminal = stateManager.getStore().getState().creditCardTerminal;
    creditCardTerminal.provider = null;
    creditCardTerminal.isConnected = false;
    creditCardTerminal.errorMessage = null;
    creditCardTerminal.underlyingDriver = null;
    var terminalSettings = stateManager.getStore().getState().terminalSettings;
    
    if (terminalSettings == null || stringUtil.isStringNullOrEmpty(cardSettingsUtils.getCardProvider()))
    {
        var errorMessage = "No Credit Card Settings Found";
        logger.warn(errorMessage);

        creditCardTerminal.errorMessage = errorMessage;
        onCompletion();
        return;
    }
    
    creditCardTerminal.provider = cardSettingsUtils.getCardProvider();
    
    if (stringUtil.isStringNullOrEmpty(creditCardTerminal.provider))
    {
        var errorMessage = "No Credit Card Provider Found";
        logger.warn(errorMessage);

        creditCardTerminal.errorMessage = errorMessage;
        onCompletion();
        return;
    }

    if (stringUtil.areStringSame(creditCardTerminal.provider, cardPaymentManagement.offline))
    {
        onCompletion();
        return;
    }


    if (stringUtil.areStringSame(creditCardTerminal.provider,cardPaymentManagement.paymentSense))
    {
        const creditCardIntegration = stateManager.getStore().getState().creditCardIntegration;
        if(creditCardIntegration == null || validator.isEmptyObject(creditCardIntegration.jsonData))
        {
            var errorMessage = `No Credit Card integration Found for: ${creditCardTerminal.provider}`;
            logger.warn(errorMessage, {}, null, creditCardTerminal.provider);

            creditCardTerminal.errorMessage = errorMessage;
            onCompletion();
            return;
        }

        creditCardTerminal.creditCardTerminalConfiguration = creditCardIntegration.jsonData;
        creditCardTerminal.underlyingDriver = paymentSenseCardTerminalDriver;
    }

    if (stringUtil.areStringSame(creditCardTerminal.provider,cardPaymentManagement.stripeReader))
    {
        const creditCardIntegration = stateManager.getStore().getState().creditCardIntegration;
        if(creditCardIntegration == null || validator.isEmptyObject(creditCardIntegration.jsonData))
        {
            var errorMessage = `No Credit Card integration Found for: ${creditCardTerminal.provider}`;
            logger.warn(errorMessage, {}, null, creditCardTerminal.provider);

            creditCardTerminal.errorMessage = errorMessage;
            onCompletion();
            return;
        }

        const operatingConfiguration = storefrontUtility.getCurrentStorefront().operatingConfiguration;
        if(operatingConfiguration == null)
        {
            var errorMessage = `No Credit Card integration could be setup without payout store configuration`
            logger.warn(errorMessage, {}, null, creditCardTerminal.provider);

            creditCardTerminal.errorMessage = errorMessage;
            onCompletion();
            return;
        }

        const { payoutStoreId, transactionPercentageFee, transactionFixedFee, transactionTaxRate, connectAccountId } = operatingConfiguration;

        if(stringUtil.isStringNullOrEmpty(payoutStoreId) 
            || stringUtil.isStringNullOrEmpty(connectAccountId) 
            || !validator.isGreaterThanOrEqualToZero(transactionPercentageFee)
            || !validator.isGreaterThanOrEqualToZero(transactionFixedFee))
        {
            var errorMessage = "Store payout configuration is not setup"
            logger.warn(errorMessage, {}, null, creditCardTerminal.provider);

            creditCardTerminal.errorMessage = errorMessage;
            onCompletion();
            return;
        }


        let paymentMetadata = {};
        paymentMetadata.payoutStoreId = payoutStoreId;
        paymentMetadata.transactionPercentageFee = transactionPercentageFee;
        paymentMetadata.transactionFixedFee = transactionFixedFee;
        paymentMetadata.transactionTaxRate = transactionTaxRate || 0;

        creditCardTerminal.creditCardTerminalConfiguration = typeUtil.deepCloneObject(creditCardIntegration.jsonData);
        creditCardTerminal.creditCardTerminalConfiguration.paymentMetadata = paymentMetadata;
        creditCardTerminal.creditCardTerminalConfiguration.connectAccountId = connectAccountId;
        creditCardTerminal.creditCardTerminalConfiguration.paymentCurrency = localizationUtils.getCurrency();

        creditCardTerminal.underlyingDriver = stripeServerSideCardTerminalDriver;
    }

    if (stringUtil.areStringSame(creditCardTerminal.provider, cardPaymentManagement.worldPay))
    {
        genericCardTerminalDriver.UnderlyingDriverName =cardPaymentManagement.worldPay;
        creditCardTerminal.underlyingDriver = genericCardTerminalDriver;
    }

    if (stringUtil.areStringSame(creditCardTerminal.provider, cardPaymentManagement.handPoint))
    {
        const creditCardIntegration = stateManager.getStore().getState().creditCardIntegration;
        if(creditCardIntegration == null || validator.isEmptyObject(creditCardIntegration.jsonData))
        {
            var errorMessage = `No Credit Card integration Found for: ${creditCardTerminal.provider}`;
            logger.warn(errorMessage, {}, null, creditCardTerminal.provider);

            creditCardTerminal.errorMessage = errorMessage;
            onCompletion();
            return;
        }

        creditCardTerminal.creditCardTerminalConfiguration = creditCardIntegration.jsonData;
        creditCardTerminal.underlyingDriver = handPointCardTerminalDriver;
    }
    
    if (creditCardTerminal.underlyingDriver == null)
    {
        var errorMessage = `No terminal driver found for terminal type ${creditCardTerminal.provider}`;
        logger.warn(errorMessage);

        creditCardTerminal.errorMessage = errorMessage;
        onCompletion();
        return;
    }

    creditCardTerminal.underlyingDriver.connect(creditCardTerminal.creditCardTerminalConfiguration, 
    () =>
    {
        creditCardTerminal.isConnected = true;
        onCompletion();
    }, 
    (error) =>
    {
        let errorMessage;
        if(!stringUtil.isStringNullOrEmpty(error.message))
            errorMessage = error.message;
        else if(typeUtil.isObject(error))
            errorMessage = JSON.stringify(error);
        else
            errorMessage = error;

        creditCardTerminal.errorMessage = errorMessage;
        logger.warn(`Error connecting to credit card terminal. ${error}`, {}, error, creditCardTerminal.provider);
        onCompletion();
    })
}
